import { render, staticRenderFns } from "./SliderMod.vue?vue&type=template&id=613f0f78"
import script from "./SliderMod.vue?vue&type=script&lang=js"
export * from "./SliderMod.vue?vue&type=script&lang=js"
import style0 from "./SliderMod.vue?vue&type=style&index=0&id=613f0f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports